import { TertiarynavMenu, TertiarynavMenuItem } from "components/navigation/tertiarynav";
import React from "react";

export const FranchiseSettingsNav: React.FC<unknown> = () => {
    return (
        <TertiarynavMenu>
            <TertiarynavMenuItem to="/settings/franchise/territories">
                Territories
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/franchise/defaults">
                New Territory Defaults
            </TertiarynavMenuItem>
        </TertiarynavMenu>
    );
};
